module.exports = __webpack_public_path__ + "img/Porto Apartment - 38 of 85.1dfa9eb5.jpeg";